import mixpanel from "mixpanel-browser";
import {
  dateDifference,
  dateTimeFormat,
} from "../../../../../Helpers/times-ago";
import { Input } from "../../../../../shadcnComponents/ui/input";
import {
  AccordionFormHeader,
  CollabFormAccordion,
  MetricsCard,
  TopPostCard,
} from "../BrandCollabComponents/BrandCollabAtomicComponent";
import { IoMdOpen } from "react-icons/io";
import { Button } from "../../../../../shadcnComponents/ui/button";
import { useAuth } from "../../../../../Providers/Auth";
import {
  Calendar,
  Eye,
  HeartIcon,
  MessageCircle,
  RefreshCw,
  Repeat2,
} from "lucide-react";
import { useEffect, useState } from "react";
import { isDevice } from "../../../../../Helpers/helper";
import { useToast } from "../../../../../shadcnComponents/ui/use-toast";
import {
  ExtensionCheckDialog,
  InstallExtensionDialogContainer,
} from "../../../../Influencer/CreateProfileV1/SyncLinkedinWithExt";
import SyncCollabPopup from "../BrandCollabComponents/BrandCollabSyncPopup";

export const GoLivePage = ({
  collab,
  PostData,
  SetPostData,
  handleSubmit,
  loadingTracking,
  handleTrackPost,
  collabId,
}) => {
  const authState = useAuth();
  const [openExtInstall, setOpenExtInstall] = useState(false);
  const [openSyncCollabPopup, setOpenSyncCollabPopup] = useState(false);
  const [isSyncSuccessful, setIsSyncSuccessful] = useState(false);
  const [extTargetUrl, setExtTargetUrl] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const { toast } = useToast();
  // const [syncStatus, setSyncStatus] = useState<boolean>();

  useEffect(() => {
    setIsMobile(isDevice().mobile);
    handleLastSyncAction(collab);
  }, [collab]);

  // useEffect(() => {
  //   if (collab?.postTracking && collabId) {
  //     if (localStorage.getItem("EXTSDT") === "true") {
  //       const prevImpressions = localStorage.getItem(`${collabId}-impression`);
  //       const currentImpressions = collab?.postTracking?.impressions;

  //       console.log("prevImpressions", prevImpressions);
  //       console.log("currentImpressions", currentImpressions);
  //       console.log(localStorage.getItem("EXTSDT"));

  //       if (prevImpressions && currentImpressions) {
  //         if (parseInt(currentImpressions) > parseInt(prevImpressions)) {
  //           setSyncStatus(true);
  //         } else {
  //           setSyncStatus(false);
  //         }
  //       } else {
  //         console.log("Impressions data is missing");
  //       }
  //     }
  //   }
  // }, [collab, collabId]);

  // useEffect(() => {
  //   if (localStorage.getItem("EXTSDT") === "true" && syncStatus !== null) {
  //     if (syncStatus) {
  //       toast({
  //         title: "Post impression synced successfully",
  //       });
  //     } else {
  //       toast({
  //         title: "Post impression sync failed",
  //         variant: "destructive",
  //       });
  //     }

  //     localStorage.removeItem("EXTSDT");
  //     localStorage.removeItem(`${collabId}-impression`);
  //   }
  // }, [syncStatus, collabId]);

  const handleGetCollabData = async () => {
    mixpanel.track(
      `Influencer Brand Collab Details  : Refresh Post Performance - clicked `
    );

    // server side scraping
    if (isMobile) {
      handleTrackPost({
        postUrl: collab?.trackingLink,
        anchorsCollabId: collab?._id,
      });
    }

    // client side scraping
    if (isMobile) {
      toast({
        title: "Please use desktop to sync",
        variant: "destructive",
      });
      return;
    } else {
      // localStorage.setItem("EXTSDT", "true"); // extension sync data trigger
      // localStorage.setItem(
      //   `${collabId}-impression`,
      //   collab?.postTracking?.impressions || 0
      // );

      setOpenExtInstall(true);

      const postlink = collab?.trackingLink?.split("?")?.[0];
      setExtTargetUrl(
        postlink + "?ref=anchors&page=singlePost&collabId=" + collabId
      );
    }
  };

  const handleLastSyncAction = (collab) => {
    const syncHistory = collab?.postTracking?.history?.sort(
      (a, b) =>
        new Date(b.timestamp)?.getTime() - new Date(a.timestamp)?.getTime()
    );
    if (syncHistory?.length > 0) {
      const latestSync = syncHistory[0];
      const isDemographicsScraped = (latestSync) => {
        return (
          latestSync?.demographics?.jobTitles?.length > 0 &&
          latestSync?.demographics?.location?.length > 0 &&
          latestSync?.demographics?.seniority?.length > 0 &&
          latestSync?.demographics?.industries?.length > 0 &&
          latestSync?.demographics?.companies?.length > 0 &&
          latestSync?.demographics?.companySize?.length > 0
        );
      };
      console.log(latestSync);
      const isWithinFiveMinutes = (
        timestamp1: Date | string,
        timestamp2: Date | string
      ): boolean => {
        const date1 =
          timestamp1 instanceof Date ? timestamp1 : new Date(timestamp1);
        const date2 =
          timestamp2 instanceof Date ? timestamp2 : new Date(timestamp2);

        const differenceInMilliseconds = Math.abs(
          date1.getTime() - date2.getTime()
        );

        const fiveMinutesInMilliseconds = 5 * 60 * 1000;

        return differenceInMilliseconds < fiveMinutesInMilliseconds;
      };

      if (
        !latestSync?.metrics?.likes ||
        !latestSync?.metrics?.impressions ||
        !isDemographicsScraped(latestSync)
      ) {
        console.log(isDemographicsScraped(latestSync));
        console.log(latestSync?.metrics);
        console.log(latestSync?.metrics?.likes);
        console.log(latestSync?.metrics?.impressions);
        setIsSyncSuccessful(false);
        setOpenSyncCollabPopup(true);
      } else if (
        isWithinFiveMinutes(latestSync?.timestamp, new Date(Date.now()))
      ) {
        setIsSyncSuccessful(true);
        setOpenSyncCollabPopup(true);
      }
    }
  };
  return (
    <>
      {openSyncCollabPopup && (
        <SyncCollabPopup
          syncHistory={collab?.postTracking?.history}
          isSyncSuccessful={isSyncSuccessful}
          handleSync={() => {
            setOpenSyncCollabPopup(false);
            handleGetCollabData();
          }}
        />
      )}
      {openExtInstall && (
        <ExtensionCheckDialog
          open={openExtInstall}
          onOpenChange={setOpenExtInstall}
          content={
            <InstallExtensionDialogContainer
              reSync={true}
              redirectUrl={`${window.location.origin}/influencer/plugin/callback`}
              extTargetUrl={extTargetUrl}
              closeCurrentWindow={true}
              open={openExtInstall}
            />
          }
        />
      )}
      <div className="w-full flex flex-col pb-5">
        <div className="flex justify-between mb-6">
          <div className="text-start space-y-2">
            <h1 className="text-[#FFF] font-[Inter] text-[20px] not-italic font-bold leading-[24px]">
              Go LIVE
            </h1>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <CollabFormAccordion
            Header={<AccordionFormHeader title="Share Post Link" />}
            ContentArray={[
              <>
                <div className="flex flex-col w-full px-4 py-3 ">
                  <div className="flex flex-col gap-[18px]">
                    <div className="flex gap-1 flex-col">
                      <span className="text-[color:var(--Natural-500,#9E9E9E)] text-sm not-italic font-semibold leading-5">
                        {collab?.trackingLink?.length
                          ? "LIVE campaign post link submitted"
                          : "Input the link to the live collaborative post"}
                      </span>
                      <span className="text-neutral-400 text-xs not-italic font-normal leading-5">
                        {collab?.trackingLink?.length
                          ? "The link will be used to track the metrics which will further define your payment"
                          : "Ensure that the link is correct since it will be used to keep track of the metrics"}
                      </span>
                    </div>
                    {!collab?.trackingLink?.length ? (
                      <Input
                        disabled={
                          !collab?.liveAt ||
                          new Date(Date.now()) < new Date(collab?.liveAt) ||
                          dateDifference(
                            new Date(Date.now()),
                            new Date(collab?.liveAt)
                          )?.days > 48
                        }
                        className=" bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                        type="text"
                        placeholder="🔗 Paste URL"
                        value={PostData?.trackingLink}
                        onChange={(e) =>
                          SetPostData({
                            ...PostData,
                            trackingLink: e.target.value,
                          })
                        }
                      />
                    ) : (
                      <span
                        onClick={() => {
                          mixpanel.track(
                            `Influencer Brand Collab Details  : Tracking Link - clicked `
                          );
                          const trackingLink = collab?.trackingLink ?? "";
                          let link = trackingLink;

                          if (!/^https?:\/\//i.test(trackingLink)) {
                            link = "https://" + trackingLink;
                          }

                          window.open(link, "_blank");
                        }}
                        className="text-[#DC2627] flex items-center gap-2  text-sm not-italic font-normal leading-6 underline cursor-pointer"
                      >
                        <span>{collab?.trackingLink?.slice(0, 50)}</span>
                        <IoMdOpen color="#DC2627" />
                      </span>
                    )}
                    {!collab?.trackingLink && (
                      <div className="w-full flex mt-[40px] ">
                        <Button
                          disabled={
                            !collab?.liveAt ||
                            new Date(Date.now()) < new Date(collab?.liveAt) ||
                            dateDifference(
                              new Date(Date.now()),
                              new Date(collab?.liveAt)
                            )?.days > 48
                          }
                          onClick={(e) => {
                            mixpanel.track(
                              `Influencer Brand Collab Details  : Submit Tracking Link - clicked `
                            );
                            new Date(Date.now()) <
                            new Date(
                              collab?.liveAt ||
                                collab?.campaignInfo?.campaignStartDate
                            )
                              ? ""
                              : handleSubmit(e, "accepted");
                          }}
                          variant="destructive"
                        >
                          Submit Post link
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </>,
            ]}
          />
          {collab?.trackingLink && (
            <CollabFormAccordion
              defaultValue={collab?.trackingLink ? "open" : ""}
              Header={<AccordionFormHeader title="Post Performance" />}
              ContentArray={[
                <>
                  <div className="flex gap-10 px-4 pb-3 mt-10">
                    {collab?.postTracking && (
                      <TopPostCard
                        name={authState?.loggedUser?.name}
                        tagline={authState?.loggedUser?.tagline}
                        postLink={collab?.trackingLink}
                        postDescription={collab?.postTracking?.postContent}
                        profile={authState?.loggedUser?.profile}
                        likes={collab?.postTracking?.likes}
                        comments={collab?.postTracking?.comments}
                        reposts={collab?.postTracking?.reposts}
                      />
                    )}
                    <div className="flex flex-col gap-5">
                      <div className="grid grid-cols-2 gap-5">
                        {[
                          {
                            icon: <Eye color="#F59E00" size={25} />,
                            title: "Impressions",
                            value: collab?.postTracking?.impressions
                              ? Math.ceil(collab?.postTracking?.impressions)
                              : "-",
                          },
                          {
                            icon: <HeartIcon color="#DC2627" size={25} />,
                            title: "Likes",
                            value: collab?.postTracking?.likes
                              ? Math.ceil(collab?.postTracking?.likes)
                              : "-",
                          },
                          {
                            icon: <MessageCircle color="#1070E0" size={25} />,
                            title: "Comments",
                            value: collab?.postTracking?.comments
                              ? Math.ceil(collab?.postTracking?.comments)
                              : "-",
                          },
                          {
                            icon: <Repeat2 color="#13931D" size={25} />,
                            title: "Reposts",
                            value: collab?.postTracking?.reposts
                              ? Math.ceil(collab?.postTracking?.reposts)
                              : "-",
                          },
                        ]?.map((item, index) => {
                          return (
                            <MetricsCard
                              key={index}
                              title={item?.title}
                              value={item?.value}
                              icon={item?.icon}
                            />
                          );
                        })}
                      </div>
                      <div className="space-y-2">
                        <div className="flex justify-center items-center">
                          <Button
                            className="w-full gap-2"
                            variant="destructive"
                            onClick={() => handleGetCollabData()}
                            disabled={loadingTracking}
                          >
                            <RefreshCw
                              size={16}
                              className={loadingTracking ? "animate-spin" : ""}
                            />
                            Sync Collab data
                          </Button>
                        </div>
                        {collab?.postTracking?.updatedAt && (
                          <p className="text-[#A6A6A6] text-center text-sm not-italic font-medium leading-[24px]">
                            Last Sync:{" "}
                            {dateTimeFormat(collab?.postTracking?.updatedAt)}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col items-end">
                      <div className="size-fit">
                        <MetricsCard
                          title="Campaign Live Date"
                          value={dateTimeFormat(collab?.liveAt)
                            .split(" ")
                            ?.map((item, index) => {
                              if (index < 3) {
                                if (index === 1)
                                  return item?.slice(0, 3) + ". '";
                                else return item + " ";
                              } else return "";
                            })
                            ?.join("")}
                          icon={<Calendar size={25} />}
                        />
                      </div>
                    </div>
                  </div>
                </>,
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};
